import React from 'react'
import ResetPWDExpired from '../components/ResetPassword/components/ResetPWDExpired'
import { forgotPasswordServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const ResetPWDExpiredWidget = injectWidget({
  widget: ResetPWDExpired,
  serviceConfig: forgotPasswordServiceConfig,
})

export default function renderResetPWDExpiredWidget(props) {
  return <div className="passport-resetpassword-expired"><ResetPWDExpiredWidget {...props} /></div>
}
